<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'

// Component Imports (Automatically registered in <script setup>)
import ListingNoContent from './ListingNoContent'
import ListingNoContentOptions from './ListingNoContentOptions'
import ListViewRow from './ListViewRow'

// Define Props
const props = defineProps({
    viewId: String
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Computed Properties
const itemCount = computed(() => viewStore.itemCount || 0)
const selectedIds = computed(() => viewStore.selectedIds || [])
const ids = computed(() => viewStore.ids || [])
</script>

<template>
    <div v-if="itemCount <= 0">
        <ListingNoContent :view-id="viewId"/>
        <ListingNoContentOptions :view-id="viewId"/>
    </div>

    <div v-else class="list-group list-group-flush">
        <ListViewRow v-for="id in ids" :id="id" :key="id" :class="{ 'active': selectedIds.indexOf(id) > -1 }"
                     :view-id="viewId" class="list-group-item"/>
    </div>
</template>

<style scoped>
.list-group-item {
    border-style: dashed;
}
</style>